import { createSelector } from 'reselect'
import isBlackFridayBFCMSelect from 'modules/black-friday-cyber-monday/redux/selectors/is-black-friday'
import isCyberMondayBFCMSelect from 'modules/black-friday-cyber-monday/redux/selectors/is-cyber-monday'

const isBlackFridayOrCyberMondayBFCMSelect = createSelector(
  isBlackFridayBFCMSelect,
  isCyberMondayBFCMSelect,
  (
    isBlackFriday,
    isCyberMonday
  ) => (isBlackFriday || isCyberMonday)
)

export default isBlackFridayOrCyberMondayBFCMSelect
